import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export function initHomepageCitiesCardsBlocks(root = document) {
  const blocks = root.querySelectorAll('.vicenza-homepage-cities-cards');

  blocks.forEach((block) => {

    const splideEl = (function findSplide() {
      if (block.classList && (block.classList.contains('splide') || block.hasAttribute('data-homepage-cities-cards-splide'))) {
        return block;
      }
      return block.querySelector('[data-homepage-cities-cards-splide], .splide, .homepage-cities-cards-splide, #homepage-cities-cards-splide');
    })();

    if (!splideEl || splideEl.dataset.splideInit) {
      return;
    }

    const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
    const enableLoop = slidesCount > 1;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const options = {
      type: enableLoop ? 'loop' : 'slide',
      autoWidth: true,
      gap: '12px',
      arrows: false,
      pagination: false,
      drag: 'free',
      snap: false,
      breakpoints: {
        576: { gap: '14px' },
        992: { gap: '12px' },
        1400: { gap: '12px' },
      },
      autoScroll : {
        speed: 1,
        pauseOnHover: true,
        pauseOnFocus: false,
        autoStart: !prefersReducedMotion,
      }
    };


    const splideInstance = new Splide(splideEl, options);
    splideInstance.mount({ AutoScroll });
    splideEl.dataset.splideInit = '1';
    block.classList.add('is-ready');
  });
}

